export default __webpack_public_path__ + "static/media/06__o_2.c9734521.jpg";